import { Transition } from '@mantine/core';
import { useIndicatorContext } from '@mygpt/app/access/indicator/hooks/useIndicatorContext';
import { useStore } from 'zustand';
import { shallow } from 'zustand/shallow';

export const IndicatorElement = () => {
  const ctx = useIndicatorContext();
  const { element, opened } = useStore(
    ctx,
    (_) => {
      return {
        opened: _.opened,
        element: _.element,
      };
    },
    shallow
  );

  return (
    <Transition mounted={opened} transition={'fade'}>
      {(styles) => {
        return <div style={styles}>{element}</div>;
      }}
    </Transition>
  );
};
